// Ref: https://github.com/bjyoungblood/es6-error
import ExtendableError from 'es6-error';

export class BaseError extends ExtendableError {
  constructor(message = '') {
    super(message);
  }
}

export function createError(attrs) {
  let message = attrs.message || '';
  let error = new Error(message);
  for (let attr in attrs) {
    error[attr] = attrs[attr];
  }
  return error;
}

// Bounded so a wrapper that nests itself cannot loop.
const MAX_WRAPPED_ERROR_DEPTH = 5;

/**
 * Resolve the {key, message} a caller can show a user, descending the `response`
 * property a data service nests the original rejection under when it re-wraps one -
 * RecapDefinitionService.getById is where the API's typed errors disappear.
 * A translation key marks an error as written for a user, so an unmarked one yields
 * null and the caller keeps its own copy. The deepest key wins: a wrapper names the
 * operation, the error it wrapped says what the user can do. Only the fields the view
 * reads come back, so an $http response's headers cannot ride along.
 */
export function getUserFacingError(error) {
  let userFacing = null;
  let candidate = error;
  let depth = 0;
  while (candidate && typeof candidate === 'object' && depth < MAX_WRAPPED_ERROR_DEPTH) {
    if (candidate.key && candidate.message) {
      userFacing = { key: candidate.key, message: candidate.message };
      if (candidate.values) {
        userFacing.values = candidate.values;
      }
    }
    candidate = candidate.response;
    depth++;
  }
  return userFacing;
}

export function getApiError(response, message, error) {
  const data = response.data;
  if (data) {
    const message = data.message;
    const errors = data.errors;
    if (message && errors && errors.length) {
      return errors.map(err => createError({
        message: err,
        error: 'APIError',
        response,
      }));
    }
  }
  return null;
}

export default BaseError;
